let hostname = window.location.hostname;
let domainurls: any;
 
if (hostname == '127.0.0.1' || hostname == 'localhost') {
  domainurls = {
    production: false,
    uriHost: 'http://localhost:9200/EDMSAPI',
    eip4uriHost: 'https://eip4dev.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://eip4devapi.lntecc.com/',
    reportHost: 'https://eip40devrpt.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'localhost',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "ea652a41-8e82-4dff-83cc-65278ed4f8d4",
    cacheLocation: "localStorage",
    localLoginUrl: "https://localhost:4200/EdmsUI/authentication/login",
    redirectUri: "https://localhost:4200/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://localhost:4200/EdmsUI/authentication/login",
    viewerUrl: "https://forgedev.lntecc.com/forgeviewer/viewer?urn=",
    compareUrl: "https://forgedev.lntecc.com/forgeviewer/compare?",
    flexLicenseKey: 'Z7X2-XJ150R-083O4B-3E3A43-4P4A45-1X3J5Z-191758-3T710X-0I5M32-31284O-1O4Q',
    currentServer: "http://localhost:4200/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };
} else if (hostname == 'edms4dev.lntecc.com') {
  domainurls = {
    production: true,
    uriHost: 'https://edms4dev.lntecc.com/edmsapi',
    eip4uriHost: 'https://eip4dev.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://eip4devapi.lntecc.com/',
    reportHost: 'https://eip40devrpt.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'edms4dev.lntecc.com',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "ea652a41-8e82-4dff-83cc-65278ed4f8d4",
    cacheLocation: "localStorage",
    localLoginUrl: "https://edms4dev.lntecc.com/EdmsUI/authentication/login",
    redirectUri: "https://edms4dev.lntecc.com/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://edms4dev.lntecc.com/EdmsUI/authentication/login",
    viewerUrl: "https://forgedev.lntecc.com/forgeviewer/viewer?urn=",
    compareUrl: "https://forgedev.lntecc.com/forgeviewer/compare?",
    flexLicenseKey: 'Z7GL-XHFI56-6O5J30-2F3Q4U-012R67-3B691S-493572-631237-5G4Q0B-1S2U',
    currentServer: "https://edms4dev.lntecc.com/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };
} else if (hostname == 'edms4qa.lntecc.com') {
  domainurls = {
    production: true,
    uriHost: 'https://edms4qa.lntecc.com/edmsapi',
    eip4uriHost: 'https://eip4qa.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://EIP4QAapi.lntecc.com/',
    reportHost: 'https://eip40qarpt.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'edms4qa.lntecc.com',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "efb09066-34f3-47ab-8567-6d1497f13f52",
    cacheLocation: "localStorage",
    localLoginUrl: "https://edms4qa.lntecc.com/EdmsUI/authentication/login",
    redirectUri: "https://edms4qa.lntecc.com/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://edms4qa.lntecc.com/EdmsUI/authentication/login",
    viewerUrl: "https://forgeqa.lntecc.com:444/forgeviewer/viewer?urn=",
    compareUrl: "https://forgeqa.lntecc.com:444/forgeviewer/compare?",
    flexLicenseKey: 'Z7GL-XHFI56-6O5J30-2F3Q4U-012R67-3B691S-493572-631237-5G4Q0B-1S2U',
    currentServer: "https://edms4qa.lntecc.com/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };

} else if (hostname == 'edms4uat.lntecc.com') {
  domainurls = {
    production: true,
    uriHost: 'https://edms4uat.lntecc.com/edmsapi',
    eip4uriHost: 'https://eip4uat.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://eip4uatapi.lntecc.com/',
    reportHost: 'https://eip40uatrpt.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'edms4uat.lntecc.com',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "130376a7-7026-4091-8031-fa962acee3f6",
    cacheLocation: "localStorage",
    localLoginUrl: "https://edms4uat.lntecc.com/EdmsUI/authentication/login",
    redirectUri: "https://edms4uat.lntecc.com/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://edms4uat.lntecc.com/EdmsUI/authentication/login",
    viewerUrl: "https://forgeuat.lntecc.com/forgeviewer/viewer?urn=",
    compareUrl: "https://forgeuat.lntecc.com/forgeviewer/compare?",
    flexLicenseKey: 'Z7GL-XHFI56-6O5J30-2F3Q4U-012R67-3B691S-493572-631237-5G4Q0B-1S2U',
    currentServer: "https://edms4uat.lntecc.com/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };
}
else if (hostname == 'edms4.lntecc.com') {
  domainurls = {
    production: true,
    uriHost: 'https://edms4.lntecc.com/edmsapi',
    eip4uriHost: 'https://eip4.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://eip4api.lntecc.com/',
    reportHost: 'https://reports.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'edms4.lntecc.com',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "a5685016-71b1-4499-9823-40c36c89c86e",
    cacheLocation: "localStorage",
    localLoginUrl: "https://edms4.lntecc.com/EdmsUI/authentication/login",
    redirectUri: "https://edms4.lntecc.com/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://edms4.lntecc.com/EdmsUI/authentication/login",
    viewerUrl: "https://forge.lntecc.com/forgeviewer/viewer?urn=",
    compareUrl: "https://forge.lntecc.com/forgeviewer/compare?",
    flexLicenseKey: 'Z7XV-XJIJ0Y-1D2349-673232-0C5B5B-2L1T1N-0Z4I0Q-4L4Z4E-3R6T4A-363N61-5H6Y',
    currentServer: "https://edms4.lntecc.com/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };
}
else if (hostname == 'edms4bfix.lntecc.com') {
  domainurls = {
    production: true,
    uriHost: 'https://edms4bfix.lntecc.com/edmsapi',
    eip4uriHost: 'https://eip4bfix.lntecc.com/',
    returnUrl: 'eiproot/login?returnUrl=eiproot/sessiontransfer',
    eip4baseUrl: 'https://eip4bfixapi.lntecc.com/',
    reportHost: 'https://reports.lntecc.com/Reports/report/',
    maxFileSizeToUpload: 10485760,
    fileTypeAccepts: '.jpg,.jpeg,.png,.gif,.mpg,.mp2,.mp4,.mpeg,.avi,.wmv,.csv,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.dwg,.rvt,.nwd,.3dm,.dwf,.dxf,.dwfx,.dwt,.rfa,.ifc,.nwc,.nwd,.rte,.dgn,.std,.mcb,.ads,.xml,.alg,.itl,.dtm,.e2k',
    cookieDomain: 'edms4bfix.lntecc.com',
    tenant: "264b9899-fe1b-430b-9509-2154878d5774",
    clientId: "a5685016-71b1-4499-9823-40c36c89c86e",
    cacheLocation: "localStorage",
    localLoginUrl: "https://edms4bfix.lntecc.com/EdmsUI/authentication/login",
    redirectUri: "https://edms4bfix.lntecc.com/EdmsUI/authcallback",
    postLogoutRedirectUri: "https://edms4bfix.lntecc.com/EdmsUI/authentication/login",
    viewerUrl: "https://forge.lntecc.com/forgeviewer/viewer?urn=",
    compareUrl: "https://forge.lntecc.com/forgeviewer/compare?",
    flexLicenseKey: 'Z7XV-XJIJ0Y-1D2349-673232-0C5B5B-2L1T1N-0Z4I0Q-4L4Z4E-3R6T4A-363N61-5H6Y',
    currentServer: "https://edms4bfix.lntecc.com/EdmsUI/",
    standardDrawingAttachmentURL: "https://eipvidhya.lntecc.com/edms/demo/DocumentUpload/"
  };
}

export const environment = domainurls;
